import humps from 'humps';

import { rtkQApi } from '..';
import { prepareQueryParams, processAPIRequestPayloadV2 } from 'utils/apiHelpers';
import { GetPaginatedRequestInterface, GetPaginatedResponseInterface } from 'commons/types/api';
import { WaiverInterface } from 'commons/types/waiverTypes';

export const waiversApi = rtkQApi.injectEndpoints({
  endpoints: (builder) => ({
    getPaginatedWaivers: builder.query<
      GetPaginatedResponseInterface<WaiverInterface>,
      GetPaginatedRequestInterface
    >({
      query: ({ partnerId, page, perPage = 10, search = '', sort = '', filters = null }) => {
        const queryParams = prepareQueryParams({
          partnerId,
          page,
          perPage,
          search,
          sort,
          filters,
        });
        return `/v3/waivers?${queryParams}`;
      },
      providesTags: ['Waivers'],
      transformResponse: (response: any) => humps.camelizeKeys(response),
    }),
    createWaiver: builder.mutation<
      WaiverInterface,
      { payload: WaiverInterface; partnerId: string }
    >({
      query: ({ payload, partnerId }) => {
        const formData = processAPIRequestPayloadV2<WaiverInterface>(payload);
        return {
          url: `/v3/waivers?partner_id=${partnerId}`,
          method: 'POST',
          body: formData,
          formData: true,
        };
      },
      invalidatesTags: ['Waivers'],
      transformResponse: (response: any) => humps.camelizeKeys(response),
    }),
    updateWaiver: builder.mutation<
      WaiverInterface,
      { payload: WaiverInterface; partnerId: string }
    >({
      query: ({ payload, partnerId }) => {
        const formData = processAPIRequestPayloadV2<WaiverInterface>(payload);
        return {
          url: `/v3/waivers/${payload.id}?partner_id=${partnerId}`,
          method: 'PUT',
          body: formData,
          formData: true,
        };
      },
      invalidatesTags: ['Waivers'],
      transformResponse: (response: any) => humps.camelizeKeys(response),
    }),
    deleteWaiver: builder.mutation<void, { id: number; partnerId: string }>({
      query: ({ id, partnerId }) => ({
        url: `/v3/waivers/${id}?partner_id=${partnerId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Waivers'],
    }),
  }),
});

export const {
  useGetPaginatedWaiversQuery,
  useCreateWaiverMutation,
  useUpdateWaiverMutation,
  useDeleteWaiverMutation,
} = waiversApi;
